module.exports = __webpack_public_path__ + "img/fangkuanzhong.cb91d737.png";